export default [
  {
    header: 'managers.mainVerticalMenu.persons',
    resource: ['manager', 'specialist'],
    action: 'read',
  },
  {
    title: 'managers.mainVerticalMenu.managers',
    icon: 'UserCheckIcon',
    resource: 'notification',
    action: 'read',
    children: [
      {
        title: 'managers.mainVerticalMenu.managersList',
        route: 'pages-managers-list',
        resource: 'manager',
        action: 'read',
      },
      {
        title: 'managers.mainVerticalMenu.managerAdd',
        route: 'pages-managers-add',
        resource: 'manager',
        action: 'create',
      },
    ],
  },
  {
    title: 'managerCategories.mainVerticalMenu.managerCategory',
    icon: 'ListIcon',
    resource: 'managerCategory',
    action: 'read',
    children: [
      {
        title: 'general.list',
        route: 'pages-manager-categories-list',
        resource: 'managerCategory',
        action: 'read',
      },
      {
        title: 'general.add',
        route: 'pages-manager-categories-add',
        resource: 'managerCategory',
        action: 'create',
      },
    ],
  },
  {
    title: 'specialists.mainVerticalMenu.specialists',
    icon: 'ShieldIcon',
    resource: 'specialist',
    action: 'read',
    children: [
      {
        title: 'specialists.mainVerticalMenu.specialistsList',
        route: 'pages-specialists-list',
        resource: 'specialist',
        action: 'read',
      },
    ],
  },
]
